import { render, staticRenderFns } from "./NotificationFundraisingStarted.vue?vue&type=template&id=639f84a0&"
import script from "./NotificationFundraisingStarted.vue?vue&type=script&lang=ts&"
export * from "./NotificationFundraisingStarted.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports